import { render, staticRenderFns } from "./FormPurchases.vue?vue&type=template&id=44b8d943&scoped=true&"
import script from "./FormPurchases.vue?vue&type=script&lang=js&"
export * from "./FormPurchases.vue?vue&type=script&lang=js&"
import style0 from "./FormPurchases.vue?vue&type=style&index=0&id=44b8d943&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b8d943",
  null
  
)

export default component.exports